module.exports = __webpack_public_path__ + "media/palenque/mayan_toilet-48b3f7b4.jpg";